module.exports = __webpack_public_path__ + "img/shiyongshuoming.6e4fc6fb.png";